<template>
    <div>
        <app-dlg
            v-if="shownRelay"
            :show-dlg.sync="shownRelay"
            title="Add Leave Record"
        >
            <template>
                <v-form ref="addLeaveRequestForm" @submit="$event.preventDefault()" :disabled="addingLeaveRecord">
                    <v-autocomplete
                        v-model="employeeId"
                        :items="employeesWithAccess"
                        item-text="name"
                        item-value="_id"
                        prepend-icon="mdi-account"
                        label="Employee"
                        color="primary"
                        outlined
                        dense
                        :rules="[validationRules.required]"
                        :error-messages="addLeaveRecordErrors"
                        ref="employeeSelect"
                    >
                    </v-autocomplete>

                    <v-menu
                        ref="startMenu"
                        v-model="startMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="format(start, 'dd MMMM yyyy')"
                                outlined
                                prepend-icon="mdi-calendar-start"
                                label="First day off"
                                color="primary"
                                class="mt-2"
                                dense
                                :rules="[validationRules.required]"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            />
                        </template>
                        <v-card color="primary">
                            <v-card-title class="mb-0 pb-0">First day off</v-card-title>
                            <v-date-picker
                                class="pt-0 mt-0"
                                v-model="startStringModel"
                                scrollable
                                color="primary"
                                @input="startMenu = false"
                            >
                            </v-date-picker>
                        </v-card>
                    </v-menu>

                    <v-menu
                        ref="startMenu"
                        v-model="endMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="format(end, 'dd MMMM yyyy')"
                                outlined
                                prepend-icon="mdi-calendar-end"
                                label="Last day off"
                                color="primary"
                                dense
                                class="mt-2"
                                :rules="[validationRules.required]"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            >
                            </v-text-field>
                        </template>
                        <v-card color="primary">
                            <v-card-title class="mb-0 pb-0">Last day off</v-card-title>
                            <v-date-picker
                                class="pt-0 mt-0"
                                v-model="endStringModel"
                                scrollable
                                color="primary"
                                @input="endMenu = false"
                                :min="startStringModel"
                            >
                            </v-date-picker>
                        </v-card>
                    </v-menu>

                    <v-text-field
                        :value="`${leaveDuration} Day${leaveDuration > 1 ? 's' : ''}`"
                        hint="*Including weekends"
                        persistent-hint
                        outlined
                        prepend-icon="mdi-calendar-end"
                        label="Duration"
                        color="primary"
                        dense
                        class="mt-2"
                        readonly
                    >
                    </v-text-field>

                </v-form>
            </template>

            <template v-slot:actions>
                <v-btn
                    class="ml-2"
                    small
                    color="primary"
                    @click="shownRelay = false"
                    outlined
                    size="small"
                    :disabled="addingLeaveRecord"
                >
                    Cancel
                </v-btn>

                <v-btn
                    @click="addLeaveRecord"
                    small
                    class="ml-2"
                    color="primary"
                    :loading="addingLeaveRecord"
                    :disabled="addingLeaveRecord"
                >
                    Add
                </v-btn>
            </template>
        </app-dlg>

    </div>
</template>

<script>

import {
    validationRules
} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";
import AppList from "@/components/Shared/AppList/AppList";
import {mapActions, mapGetters} from "vuex";
import {
    differenceInDays, endOfDay,
    endOfMonth,
    format,
    isSameDay,
    isSameMonth,
    isSameYear, startOfDay,
    startOfMonth,
    subDays
} from "date-fns";

export default {
    components: {AppList, AppDlg},
    props: {
        shown: Boolean,
        presetEmployeeId: String,
        presetStart: Date,
    },
    data() {
        return {
            addingLeaveRecord: false,
            start: new Date(),
            end: new Date(),
            employeeId: null,
            addLeaveRecordErrors: null,
            validationRules,

            startMenu: false,
            endMenu: false,
        }
    },
    mounted() {
        // this.refreshData();
    },

    watch: {
        "shown": {
            immediate: true,
            handler(val) {
                if (val) {
                    this.start = this.presetStart || new Date();
                    this.end = this.presetStart || new Date();
                    this.employeeId = this.presetEmployeeId || null;
                    setTimeout(() => {this.$refs.employeeSelect.focus()}, 500)
                    this.addingLeaveRecord = false
                }
            }
        },
        selectedEmployee() {
            this.addLeaveRecordErrors = null
        },
        start() {
            this.addLeaveRecordErrors = null
            if (startOfDay(this.start) > startOfDay(this.end))
                this.end = new Date(this.start)
        },
        end() {
            this.addLeaveRecordErrors = null
        }
    },

    methods: {
        differenceInDays,
        subDays,
        ...mapActions(["gotoEmployee", "gotoEmployeeSettings", "gotoTeam", "updateSelections"]),
        format,
        async addLeaveRecord() {

            if (!this.$refs.addLeaveRequestForm.validate())
                return this.$snack("Please compleete all required fields")

            try {
                this.addingLeaveRecord = true
                const {leaveRecord, overlapping} = await this.$newReq('POST', 'leave/addLeave', {
                    employeeId: this.employeeId,
                    start: startOfDay(this.start),
                    end: endOfDay(this.end)
                })

                if (overlapping)
                    this.addLeaveRecordErrors = [`Overlapping dates exist for ${this.selectedEmployee.name}`]
                else {
                    this.$emit("input", leaveRecord)
                    this.$snack.info("Leave record added")
                    this.shownRelay = false
                }
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.addingLeaveRecord = false
            }
        },
    },
    computed: {
        ...mapGetters(['access', 'employeesWithAccess', 'employeesRef']),

        selectedEmployee() {
            return this.employeeId ? this.employeesRef[this.employeeId] : null
        },

        leaveDuration() {
            return differenceInDays(startOfDay(this.end), startOfDay(this.start)) + 1
        },

        startStringModel: {
            get() {
                return format(this.start, 'yyyy-MM-dd')
            },
            set(val) {
                this.start = new Date(val)
            }
        },

        endStringModel: {
            get() {
                return format(this.end, 'yyyy-MM-dd')
            },
            set(val) {
                this.end = new Date(val)
            }
        },

        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit("update:shown", val)
            }
        },
    },
}
</script>

<style scoped>

.allOverflowHidden * {
    overflow: hidden !important;
    overflow-y: hidden !important;
    overflow-x: hidden !important;
    height: unset !important;
}

</style>